import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
// import { Link } from '@bd/bdcore-named-routes';
import { css } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl, SanitizeHtml } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';

const styles = css`
  background-image: url('/images/page-header-bg-03.jpg');
  background-size: cover;
  background-position: center center;
  height: calc(100vh - 120px);
  width: 100vw;
  margin-top:60px;
  padding: 0 0 0 0;
  position: relative;
  display: flex;
  flex-flow:column wrap;
  justify-content: center;
  @media (min-width: 992px) {
    height: calc(100vh - 80px);
    margin-bottom:80px;
  }
  .HeroImage_headlineWrapper {
    width: 100%;
    padding: 15px 0;
    text-align: center;

    .btn-dog {
      display:none;
      @media (min-width: 480px) {
        display:inline-block;
      }
    }
  }
  .HeroImage_headline {
    text-align: center;
    display:inline-block;
    background:rgba(1,35,64,.7);
    color: #FFFFFF;
    font:400 54px/1 ${typography.Display};
    padding:20px;
    @media (min-width: 480px) {
      font:400 100px/1 ${typography.Display};
    }
    @media (min-width: 992px) {
      font:400 160px/1 ${typography.Display};
    }
  }
  h3 {
    margin-top:-30px;
  }
  .HeroImage_subheadline {
    text-align: center;
    padding:10px;
    display: inline-block;
    margin:0 20px 20px 20px;
    background:rgba(255,255,255,1);
    color:  ${colors.color1};
    font:400 18px/1.3 ${typography.SansSerif};
    @media (min-width: 992px) {
      font:400 24px/1.3 ${typography.SansSerif};
    }
  }
  .HeroImage_arrow {
    display:none;
    @media (min-width: 992px) {
      display: block;
      position:absolute;
      bottom:-40px;
      left: calc(50% - 40px);
    }
  }
`;

class HeroImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      headerImage: undefined,
    };
  }

  componentDidMount() {
    this.getHeaderImage();
  }

  getHeaderImage() {
    let { headerImage } = this.state;

    if (!headerImage) {
      headerImage = _.sample(_.get(this.props.page, 'header_images'));

      this.setState({
        headerImage: buildThumbnailUrl(_.get(headerImage, 'contentUrl'), { width: 2000, height: 2000 }),
      });
    }
  }

  render() {
    const { page } = this.props;
    const { headerImage } = this.state;
    return (
      <div
        className={styles}
        style={{ backgroundImage: `url('${headerImage}')` }}
      >
        <div className="HeroImage_headlineWrapper">
          <h2 dangerouslySetInnerHTML={SanitizeHtml(_.get(page.header_content[0], 'headline'))} className="HeroImage_headline" />
          <h3>
            <div className="HeroImage_subheadline" dangerouslySetInnerHTML={SanitizeHtml(_.get(page.header_content[0], 'subheadline'))} />
          </h3>
          {
            page.header_content[0].links.map(item => (
              <a href={item.link_url} key={item.link_url} className="btn-dog">{item.link_text}</a>
            ))
          }
          {/* <Link name="photo-gallery" className="btn-dog">{_.get(page.header_content[0].links[0],
             'link_text')}</Link>
          <Link name="homes" className="btn-dog">{_.get(page.header_content[0].
          links[1], 'link_text')}</Link> */}
        </div>
        {/* <img src="/images/icon-down-arrow.png" alt="" className="HeroImage_arrow" /> */}
      </div>
    );
  }
}

HeroImage.propTypes = {
  page: PropTypes.object.isRequired,
};

export default HeroImage;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HeroImage.js